import { Panel } from '@app/components/common/Collapse/Collapse';
import React, { useEffect } from 'react';
import DealRoomAgencyInfo from '../DealRoomAgencyInfo/DealRoomAgencyInfo';
import * as S from '../DealRoomLanding.styles';
import DealRoomTeams from '../DealRoomTeams/DealRoomTeams';
import DealRoomTestimonials from '../DealRoomTestimonials/DealRoomTestimonials';

export const Opening: React.FC = () => {
  const [activeKey, setActiveKey] = React.useState<string>('');

  useEffect(() => {
    setTimeout(() => {
      const el = document.getElementById(activeKey);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }, 400);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey]);

  return (
    <>
      <S.ChildContainer className="child-container">
        <S.ChildCollapse accordion activeKey={activeKey} onChange={(key) => setActiveKey(key as string)}>
          <Panel header="מי אנחנו" id="who-we-are" key="who-we-are">
            <DealRoomAgencyInfo />
          </Panel>
          <Panel header="הצוות שלנו" id="our-team" key="our-team">
            <DealRoomTeams />
          </Panel>
          <Panel header="מה הלקוחות שלנו אומרים?" id="our-customers" key="our-customers">
            <DealRoomTestimonials />
          </Panel>
          <Panel header="צפו במה הלקוחות שלנו אומרים" id="see-what-say" key="see-what-say">
            <S.VideoWrapper
              className="elementor-video-iframe"
              allowFullScreen
              allow="clipboard-write"
              title="vimeo נגן וידאו"
              src="https://player.vimeo.com/video/1043250472?color&amp;autopause=0&amp;loop=0&amp;muted=0&amp;title=1&amp;portrait=1&amp;byline=1&amp;h=93434cb4d3#t="
            ></S.VideoWrapper>
          </Panel>
        </S.ChildCollapse>
      </S.ChildContainer>
    </>
  );
};
